"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeavyMetalBioremediation = void 0;
var Card_1 = require("../../Card");
var CardType_1 = require("../../CardType");
var CardName_1 = require("../../../CardName");
var CardRenderer_1 = require("../../render/CardRenderer");
var Tags_1 = require("../../Tags");
var OrOptions_1 = require("../../../inputs/OrOptions");
var SelectOption_1 = require("../../../inputs/SelectOption");
var SelectAmount_1 = require("../../../inputs/SelectAmount");
var Resources_1 = require("../../../Resources");
var CardRequirements_1 = require("../../CardRequirements");
var HeavyMetalBioremediation = (function (_super) {
    __extends(HeavyMetalBioremediation, _super);
    function HeavyMetalBioremediation() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.HEAVY_METAL_BIOREMEDIATION,
            cost: 10,
            tags: [Tags_1.Tags.MICROBE, Tags_1.Tags.BUILDING],
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.oxygen(9); }),
            metadata: {
                cardNumber: 'L309',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action(undefined, function (eb) {
                        eb.text('x').steel(1).startAction.megacredits(0);
                    }).br;
                    b.or().br;
                    b.action(undefined, function (eb) {
                        eb.text('x').titanium(1).startAction.megacredits(0);
                    }).br;
                }),
                description: 'Convert up to 3 of a metal for it\'s monetary value (including bonuses).',
                victoryPoints: 1,
            },
        }) || this;
    }
    HeavyMetalBioremediation.prototype.play = function () {
        return undefined;
    };
    HeavyMetalBioremediation.prototype.getVictoryPoints = function () {
        return 1;
    };
    HeavyMetalBioremediation.prototype.canAct = function (player) {
        return player.steel > 0 || player.titanium > 0;
    };
    HeavyMetalBioremediation.prototype.action = function (player) {
        var _this = this;
        var availableSteel = Math.min(3, player.steel);
        var availableTitanium = Math.min(3, player.titanium);
        var orOptions = new OrOptions_1.OrOptions();
        if (availableSteel >= 1) {
            orOptions.options.push(new SelectOption_1.SelectOption('Convert up to 3 steel for it\'s monetary value (including bonuses).', 'Convert steel', function () {
                return _this.convSteelOption(player, availableSteel);
            }));
        }
        if (availableTitanium >= 1) {
            orOptions.options.push(new SelectOption_1.SelectOption('Convert up to 3 titanium for it\'s monetary value (including bonuses).', 'Convert titanium', function () {
                return _this.convTitaniumOption(player, availableTitanium);
            }));
        }
        if (orOptions.options.length === 1)
            return orOptions.options[0].cb();
        return orOptions;
    };
    HeavyMetalBioremediation.prototype.convSteelOption = function (player, availableSteel) {
        return new SelectAmount_1.SelectAmount('Select amount of steel to spend', 'Gain MC', function (amount) {
            player.addResource(Resources_1.Resources.MEGACREDITS, player.getSteelValue() * amount);
            player.deductResource(Resources_1.Resources.STEEL, (amount));
            player.game.log('${0} gained ${1} MC', function (b) { return b.player(player).number(player.getSteelValue() * amount); });
            return undefined;
        }, 1, availableSteel);
    };
    HeavyMetalBioremediation.prototype.convTitaniumOption = function (player, availableTitanium) {
        return new SelectAmount_1.SelectAmount('Select amount of titanium to spend', 'Gain MC', function (amount) {
            player.addResource(Resources_1.Resources.MEGACREDITS, player.getTitaniumValue() * amount);
            player.deductResource(Resources_1.Resources.TITANIUM, (amount));
            player.game.log('${0} gained ${1} MC', function (b) { return b.player(player).number(player.getTitaniumValue() * amount); });
            return undefined;
        }, 1, availableTitanium);
    };
    return HeavyMetalBioremediation;
}(Card_1.Card));
exports.HeavyMetalBioremediation = HeavyMetalBioremediation;
//# sourceMappingURL=HeavyMetalBioremediation.js.map